import { useDispatch, useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { GreenroomState as GS } from '../../../stores/types/types';
import { SocketContext } from '../../../contexts/socket';
import { Message } from '../../../connection/socket';
import { setOnsiteLocationSession } from '../../../stores/actions/video';
import { LOCATION_PUBLISHING_ROUTES, OnsiteLocationSessionRoute } from '../../../stores/reducers/video';

interface KickOnsitePublisherMessage extends Message {
	message: {
		fromOnsiteLocationId: number;
		fromSession: string;
	};
}

const useKickLocationPublishers = () => {
	const dispatch = useDispatch();
	const session = useSelector((s: GS) => s.SessionReducer.session);
	const onsiteLocationSession = useSelector((s: GS) => s.VideoReducer.onsiteLocationSession);

	const { socket } = useContext(SocketContext);

	function handleDisconnect() {
		if (onsiteLocationSession?.route === OnsiteLocationSessionRoute.LimitedInputCanvas) {
			// redirect to the conference auth page
			window.location.href = `${process.env.REACT_APP_LOGIN_URL}/conference-auth`;
		} else if (onsiteLocationSession?.route === OnsiteLocationSessionRoute.Publishing) {
			dispatch(setOnsiteLocationSession({
				id: onsiteLocationSession.id,
				route: OnsiteLocationSessionRoute.Entry,
			}));
		}
	}

	function handleKickPublisher({ message }: KickOnsitePublisherMessage) {
		const {
			fromOnsiteLocationId,
			fromSession,
		} = message;

		if (
			fromOnsiteLocationId === onsiteLocationSession?.id
			&& fromSession !== session
		) {
			handleDisconnect();
		}
	}

	useEffect(() => {
		if (
			onsiteLocationSession
			&& LOCATION_PUBLISHING_ROUTES.includes(onsiteLocationSession.route)
		) {
			socket?.addListener('kick-onsite-location-publishers', handleKickPublisher);
		}
		return () => {
			socket?.removeListener('kick-onsite-location-publishers');
		};
	}, []);
};

export default useKickLocationPublishers;
